import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import classes from "../../ZipCodeSelectionSlide.module.scss";

type SavedZipCodesProps = {
  zipCodes: string[];
};

const SavedZipCodes: FC<SavedZipCodesProps> = ({ zipCodes }) => {
  return (
    <div className={classes.selectedZipCodesContainer}>
      <Typography variant="h2">Selected Zip Codes</Typography>
      <ul className={classes.zipCodes}>
        {zipCodes.map((zipCode: string) => (
          <li key={zipCode}>{zipCode}</li>
        ))}
      </ul>
    </div>
  );
};

export default SavedZipCodes;
